import React from 'react';
import './Difference.css';
import matthImg from '../images/Matt.png'
import brianImg from '../images/Brian.png'
import homieImg from '../images/Homie.png'
import mitchImag from '../images/Mitch.png'
import ismailImg from '../images/Ismail.png'
import emmaImg from '../images/Emma.png'
import UrsulaImg from '../images/Ursula.png'
import NisheetImg from '../images/Nisheet.png'
import craigImg from '../images/Craig.png'
import companyImage from '../images/OurCompany.png'

function Difference() {
  return (
    <div className="difference-container">
      {/*------Our Company------*/}
      <div className="container d-flex align-items-center justify-content-between flex-wrap">
        <div className="difference-text-header" style={{ marginTop: '0px' }}>
          <h2>Your Partner for Digitally Assisted Wealth Management</h2>
          <p>
            Cloudvisor was founded to transform wealth management by combining augmented intelligence and automation
            to reduce advisor burden and deliver better investor outcomes. Our team came together to commercialize a
            powerful platform adapted from our founder's previous venture - a proven technology stack developed at millions of
            dollars and battle-tested at scale,
            including handling up to 80% of TSX volume during special
            charity trading days. With that foundation and a clear vision, we're building the next generation of WealthTech
            that empowers advisors to focus on what matters most: their clients.
          </p>
        </div>
        {/* Right Column */}
        {/*---Solution Image---*/}
        <div className="difference-image" style={{ marginTop: '100px' }}>
          <br />
          <img src={companyImage} alt="Investment Illustration" />
        </div>
      </div>

      {/*---Leadership Team---*/}
      <div className="container d-flex align-items-center justify-content-between flex-wrap">
        <div className="difference-text-header">
          <h3>Leadership Team </h3>
        </div>
      </div>

      <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-200px' }}>
        {/*---Matt Image & Doc--- */}
        <div className="difference-text-header">
          <a href="https://www.linkedin.com/in/matthewbosrock/" target="_blank" rel="noopener noreferrer" title="LinkedIn Profile" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="feature-card">
              <div className="difference-image">
                <p>
                  <img src={matthImg} alt="Investment Illustration" style={{ width: '168px' }} />
                </p>
                <p style={{ textAlign: 'center' }}><b>Matt Bosrock</b><br />
                  <b>Executive Chair</b>
                </p>
                <p style={{ textAlign: 'justify', fontSize: '0.9rem' }}>An entrepreneurial and innovative professional with
                  strong business acumen, a keen understanding of leveraging technology, and an ability to build valuable
                  companies and meaningful relationships.
                </p>
              </div>
            </div>
          </a>
        </div>
        {/*---Brain Image & Doc--- */}
        <div className="difference-text-header">
          <a href="https://www.linkedin.com/in/brian-j-fitzgerald/" target="_blank" rel="noopener noreferrer" title="LinkedIn Profile" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="feature-card">
              <div className="difference-image">
                <p>
                  <img src={brianImg} alt="Investment Illustration" style={{ width: '168px' }} />
                </p>
                <p style={{ textAlign: 'center' }}><b>Brain J. "Fitz" Fizgerald</b><br />
                  <b>CEO</b>
                </p>
                <p style={{ textAlign: 'justify', fontSize: '0.9rem' }}>A business builder with over 20 years of experience scaling
                  up innovative products and services across the Investment Services industry that support the Advisor community.
                </p>
              </div>
            </div>
          </a>
        </div>
        {/*---Homie Image & Doc--- */}
        <div className="difference-text-header">
          <a href="https://www.linkedin.com/in/homie-malakooti-353268/" target="_blank" rel="noopener noreferrer" title="LinkedIn Profile" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="feature-card">
              <div className="difference-image">
                <p>
                  <img src={homieImg} alt="Investment Illustration" style={{ width: '168px' }} />
                </p>
                <p style={{ textAlign: 'center' }}><b>Homie Malakooti</b><br />
                  <b>CTO & CPO</b>
                </p>
                <p style={{ textAlign: 'justify', fontSize: '0.9rem' }}>A Digital innovator with extensive experience transforming
                  financial service businesses using technical expertise, and a startup builder with multiple successful exits
                  across the globe.
                </p>
              </div>
            </div>
          </a>
        </div>
        {/*---Mitch Image & Doc--- */}
        <div className="difference-text-header">
          <a href="https://www.linkedin.com/in/mitch-benton-b377132/" target="_blank" rel="noopener noreferrer" title="LinkedIn Profile" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="feature-card">
              <div className="difference-image">
                <p>
                  <img src={mitchImag} alt="Investment Illustration" style={{ width: '168px' }} />
                </p>
                <p style={{ textAlign: 'center' }}><b>Mitch Benton</b><br />
                  <b>CCO</b>
                </p>
                <p style={{ textAlign: 'justify', fontSize: '0.9rem' }}>A seasoned WealthTech leader who turns complex industry
                  challenges into scalable, advisor-focused solutions by bridging business and technology to drive innovation
                  and lasting impact.
                </p>
              </div>
            </div>
          </a>
      </div>


        {/*------Advisory Board------*/}
        {/* <div className="container d-flex align-items-center justify-content-between flex-wrap">
          <div className="difference-text-header">
            <br /><br />
            <h3>Advisory Board</h3>
          </div>
        </div> */}

        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-150px' }}>

          {/*---Emma Image & Doc--- */}
          {/* <div className="difference-text-header">
            <div className="feature-card">
              <div className="difference-image">
                <p>
                  <img src={emmaImg} alt="Investment Illustration" style={{ width: '168px' }} />
                </p>
                <p style={{ textAlign: 'center' }}><b>Emma Purdy</b><br />
                  <b>Advisory Board - Chair</b>
                </p>
                <p style={{ textAlign: 'justify', fontSize: '0.9rem' }}>A globally recognized leader in professional services,
                  governance, and financial innovation with a track record of growing fintech companies.
                </p>
              </div>
            </div>
          </div> */}
          {/*---Ismail Image & Doc--- */}
          {/* <div className="difference-text-header" >
            <div className="feature-card">
              <div className="difference-image">
                <p>
                  <img src={ismailImg} alt="Investment Illustration" style={{ width: '168px' }} />
                </p>
                <p style={{ textAlign: 'center' }}><b>Ismail Pishori</b><br />
                  <b>Advisory Board – Founder</b>
                </p>
                <p style={{ textAlign: 'justify', fontSize: '0.9rem' }}>A SaaS expert with 30 years of experience in technology sales,
                  marketing, and business and corporate development targeting Financial services.
                </p>
              </div>
            </div>
          </div> */}

          {/*---Ursula Holmsten--- */}
          {/* <div className="difference-text-header">
            <div className="feature-card">
              <div className="difference-image">
                <p>
                  <img src={UrsulaImg} alt="Investment Illustration" style={{ width: '168px' }} />
                </p>
                <p style={{ textAlign: 'center' }}><b>Ursula Holmsten</b><br />
                  <b>Advisory Borad</b>
                </p>
                <p style={{ textAlign: 'justify', fontSize: '0.9rem' }}>Seasoned investment industry executive with over 20+ years of strategic leadership across banking, wealth management, investment management, finance, operations, and risk.
                </p>
              </div>
            </div>
          </div> */}

          {/*---Nisheet Patel Image & Doc--- */}
          {/* <div className="difference-text-header" >
            <div className="feature-card">
              <div className="difference-image">
                <p>
                  <img src={NisheetImg} alt="Investment Illustration" style={{ width: '168px' }} />
                </p>
                <p style={{ textAlign: 'center' }}><b>Nisheet Patel</b><br />
                  <b>Advisory Board</b>
                </p>
                <p style={{ textAlign: 'justify', fontSize: '0.9rem' }}>Senior industry professional with 20+ years of experience leading wealth platform strategy and development at leading Wirehouses and BD/RIAs; specializing in FA/Client experiences and field adoption.
                </p>
              </div>
            </div>
          </div> */}
        </div>



        {/*------Advisory Board------*/}
        <div className="container d-flex align-items-center justify-content-between flex-wrap">
          <div className="difference-text-header">
            <br /><br />
            <h3>Advisory Team</h3>
          </div>
        </div>

        <div className="container d-flex align-items-center justify-content-between flex-wrap" style={{ marginTop: '-150px' }}>

          {/*---Emma Image & Doc--- */}
          <div className="difference-text-header">
            <a href="https://www.linkedin.com/in/emmajpurdy/" target="_blank" rel="noopener noreferrer" title="LinkedIn Profile" style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="feature-card">
                <div className="difference-image">
                  <p>
                    <img src={emmaImg} alt="Investment Illustration" style={{ width: '168px' }} />
                  </p>
                  <p style={{ textAlign: 'center' }}><b>Emma Purdy</b><br />
                    <b>Advisory Board - Chair</b>
                  </p>
                  <p style={{ textAlign: 'justify', fontSize: '0.9rem' }}>A globally recognized leader in professional services,
                    governance, and financial innovation with a track record of growing fintech companies.
                  </p>
                </div>
              </div>
            </a>
          </div>
          {/*---Ismail Image & Doc--- */}
          <div className="difference-text-header" > 
            <a href="https://www.linkedin.com/in/ismail-pishori-532723/" target="_blank" rel="noopener noreferrer" title="LinkedIn Profile" style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="feature-card">
                <div className="difference-image">
                  <p>
                    <img src={ismailImg} alt="Investment Illustration" style={{ width: '168px' }} />
                  </p>
                  <p style={{ textAlign: 'center' }}><b>Ismail Pishori</b><br />
                    <b>Advisory Board – Founder</b>
                  </p>
                  <p style={{ textAlign: 'justify', fontSize: '0.9rem' }}>A SaaS expert with 30 years of experience in technology sales,
                    marketing, and business and corporate development targeting Financial services.
                  </p>
                </div>
              </div>
            </a>
          </div>
          {/*---Nisheet Patel Image & Doc--- */}
          <div className="difference-text-header" >
            <a href="https://www.linkedin.com/in/nisheetpatel/" target="_blank" rel="noopener noreferrer" title="LinkedIn Profile" style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="feature-card">
                <div className="difference-image">
                  <p>
                    <img src={NisheetImg} alt="Investment Illustration" style={{ width: '168px' }} />
                  </p>
                  <p style={{ textAlign: 'center' }}><b>Nisheet Patel</b><br />
                    <b>Advisory Board</b>
                  </p>
                  <p style={{ textAlign: 'justify', fontSize: '0.9rem' }}>Senior industry professional with 20+ years of experience leading wealth platform strategy and development at leading Wirehouses and BD/RIAs; specializing in FA/Client experiences and field adoption.
                  </p>
                </div>
              </div>
            </a>
          </div>
          {/*---Craig Iannucci Holmsten--- */}
          <div className="difference-text-header">
            <a href="https://www.linkedin.com/in/craigiannucci/" target="_blank" rel="noopener noreferrer" title="LinkedIn Profile" style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="feature-card">
                <div className="difference-image">
                  <p>
                    <img src={craigImg} alt="Investment Illustration" style={{ width: '168px' }} />
                  </p>
                  <p style={{ textAlign: 'center' }}><b>Craig Iannucci</b><br />
                    <b>Advisor</b>
                  </p>
                  <p style={{ textAlign: 'justify', fontSize: '0.9rem' }}>A unique combination of operational expertise around building a FinTech and the detail-oriented, results-driven vigor of top-level investing.
                  </p>
                </div>
              </div>
            </a>
          </div>

        </div>


        {/*------Site Footer------*/}
      </div>
      <footer className="site-footer">
        <div className="container text-center">
          <p>&copy; {new Date().getFullYear()} Cloudvisor DigitalAssociate. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default Difference;